import React from 'react'
import { api } from '../../api/client'
import { screenCache } from '../../api/screenCache'
import type { FreedomCard } from '../../types/app'
import { useBilling } from '../../billing/useBilling'

// useFreedom is the last completed week's Freedom Score, which comes with the
// month's earnings. Only Goals shows it (owner, 2026-10-19: not on Today);
// the cache shows the score at once on a return to Goals while it refreshes.
// It never holds the screen back: if the request fails there is simply no
// score.
// A request token keeps a stale reply out. The score is Pro's: off Pro
// it is null whatever the cache or a reply carries (a score cached while she
// was on Pro must not show).
export function useFreedom(): FreedomCard | null {
  const { coachLocked } = useBilling()
  const [freedom, setFreedom] = React.useState<FreedomCard | null>(() => screenCache.get<FreedomCard | null>('freedom') ?? null)
  const latest = React.useRef(0)
  React.useEffect(() => {
    const request = ++latest.current
    api
      .getEarnings()
      .then((e) => {
        if (request !== latest.current) return
        setFreedom(e.freedom)
        screenCache.set('freedom', e.freedom)
      })
      .catch(() => {})
    return () => {
      latest.current++
    }
  }, [])
  return coachLocked ? null : freedom
}
